import { useQuery } from '@tanstack/react-query';
import { countStoredRfqFiles } from '../api/rfqFiles';
import { queryKeys } from '../api/queryKeys';

export const useAttachmentCount = (rfqId: number) => {
  return useQuery({
    queryKey: queryKeys.attachmentCount(rfqId),
    queryFn: async () => {
      // Only count files with valid storage paths and buckets
      const { count, error } = await countStoredRfqFiles(rfqId);

      if (error) {
        console.error('Error fetching attachment count:', error);
        return 0;
      }
      
      return count || 0;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}; 